module.exports = __webpack_public_path__ + "static/media/p1-t.c1b71213.jpg";